import { render, staticRenderFns } from "./leftTwo.vue?vue&type=template&id=0ec70267&scoped=true&"
import script from "./leftTwo.vue?vue&type=script&lang=js&"
export * from "./leftTwo.vue?vue&type=script&lang=js&"
import style0 from "./leftTwo.vue?vue&type=style&index=0&id=0ec70267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec70267",
  null
  
)

export default component.exports